






























































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy, Accion } from '@/config/enums';
@Component({
  components: {},
})
export default class ConfigurarDetalleForm extends Vue {
  @Prop() readonly patente!: string;
  @Prop() readonly estado!: string;

  loadingPDF: boolean = true;
  ordenesServicio: Array<any> = [];
  selectedOrdenServicio: string = '';
  axios: AxiosVue = new AxiosVue(ServicioProxy.MS);
  isFormValid: boolean = false;
  url: string = '';

  //ejecuta la función onPatenteChanged cada vez que la propiedad patente del componente cambie su valor.
  @Watch('patente')
  onPatenteChanged(newValue: string) {
    console.log('En ConfigurarDetalleForm - Nuevo valor de patente:', newValue);
    // Restablece la selección de la orden de servicio y carga las nuevas órdenes.
    this.selectedOrdenServicio = '';
    this.url = ''; //  limpia la URL del PDF para evitar mostrar un PDF no deseado.
    this.cargarOrdenesServicio();
  }

  mounted() {
    console.log('mensaje desde configurardetalleform');
    this.cargarOrdenesServicio();
  }

  // Observa cambios en la propiedad 'selectedOrdenServicio'. Cada vez que su valor cambie, se ejecutará la función 'actualizarPDF'.
  @Watch('selectedOrdenServicio')
  actualizarPDF(newValue: string) {
    if (newValue) {
      const ordenSeleccionada = this.ordenesServicio.find(
        orden => orden.orden_servicio === newValue
      );
      const nuevaUrl = ordenSeleccionada ? ordenSeleccionada.url : '';
      if (this.url !== nuevaUrl) {
        this.url = nuevaUrl;
      }
    } else {
      this.url = ''; // Limpia la URL del PDF si no hay una orden seleccionada
    }
  }

  cargarOrdenesServicio() {
    this.axios.http
      .post(
        'Metabase/PostgenericA/CuadraturaServicios/getOrdenesServicioPorSerie',
        { serienumero: this.patente }
      )
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          //  código de respuesta es '1', actualiza las órdenes de servicio con los datos recibidos
          this.ordenesServicio = response.data.data;

          if (this.ordenesServicio.length > 0 && !this.selectedOrdenServicio) {
            this.selectedOrdenServicio = this.ordenesServicio[0].orden_servicio;
            // Actualiza el PDF de acuerdo con la orden de servicio por defecto
            this.actualizarPDF(this.selectedOrdenServicio);
          }
        } else {
          console.error(
            'Error al cargar las órdenes de servicio:',
            response.data.MENSAJE_RESPUESTA
          );
          this.ordenesServicio = [];
        }
      })
      .catch((error: any) => {
        // Maneja los errores que pueden ocurrir durante la petición HTTP
        console.error('Error al realizar la petición:', error);
        this.ordenesServicio = []; // Limpia el arreglo en caso de error
      });
  }
}
